<template>
<div>
    <div>
        <div class="mt-2 flex gap-2 text-red-500" v-if="job.error">
            <ElIconCircleCloseFilled :width="16"></ElIconCircleCloseFilled> Operation failed: {{ job.error }}
        </div>
        <div class="mt-2" v-else>
            <el-tag class="mr-1" type="warning" effect="dark" v-if="job.type == 'drm'">DRM</el-tag> 
            <span class="text-xs font-medium text-gray-600">
                <span v-if="state.progress.bytesDone" class="mr-2">
                    {{ formatBytes(state.progress.bytesDone) }} / {{ formatBytes(state.progress.bytesTotal || state.progress.total) }}
                </span>
                <span v-if="state.speed" class="ml-1">Speed: {{ state.speed }}</span>
            </span>
        </div>
        <div class="mt-2 flex gap-2">
            <el-progress class="flex-grow" :text-inside="true" :stroke-width="18" :percentage="Math.round((state.progress.progress || 0) * 100)"></el-progress>
            
            <template v-if="job.type == 'hls' || job.type == 'dash' || job.type == 'download' || job.type == 'chunked' || job.type == 'native'">
                <el-button v-if="job.status == 'running'" style="zoom: 1.2; height: auto; padding: 0" class="flex-shrink" type="text" @click="pauseJob(job)">
                    <el-icon :size="20"><ElIconVideoPause /></el-icon>
                </el-button>
                <el-button v-if="job.status == 'paused' || job.status == 'error'" style="zoom: 1.2; height: auto; padding: 0" class="flex-shrink" type="text" @click="resumeJob(job)">
                    <div class="flex items-center gap-1">
                        <el-icon :size="20"><ElIconVideoPlay /></el-icon>
                        <span class="text-xs">Resume</span>
                    </div>
                </el-button>
            </template>

            <el-button style="zoom: 1.2; height: auto; padding: 0" class="flex-shrink" type="text" @click="cancelJob(job)">
                <el-icon :size="20"><ElIconCircleCloseFilled /></el-icon>
            </el-button>
        </div>
    </div>
</div>
</template>

<script>
import { CircleCloseFilled as ElIconCircleCloseFilled, VideoPause as ElIconVideoPause, VideoPlay as ElIconVideoPlay } from '@element-plus/icons-vue'

export default {
    components: {
        ElIconCircleCloseFilled,
        ElIconVideoPause,
        ElIconVideoPlay
    },
    props: ['job'],
    setup() {
        const {cancelJob, useExtension} = useHelpers()
        return {cancelJob, useExtension}
    },
    methods: {
        formatBytes(bytes) {
            if (!bytes) return '0 B'
            const k = 1024
            const sizes = ['B', 'KB', 'MB', 'GB', 'TB']
            const i = Math.floor(Math.log(bytes) / Math.log(k))
            return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
        },
        async pauseJob (job) {
            if (job.type == 'hls') {
                await useExtension('hlsDownloadPool.pauseJob', [job.id], 'offscreen')
            } else if (job.type == 'dash') {
                await useExtension('dashDownloadPool.pauseJob', [job.id], 'offscreen')
            } else if (job.type == 'chunked') {
                await useExtension('chunkedDownloadPool.pauseJob', [job.id], 'offscreen')
            } else if (job.type == 'native') {
                await useExtension('nativeDownloadPool.pauseJob', [job.id], 'offscreen')
            } else if (job.type == 'download') {
                await useExtension('downloadPool.pauseJob', [job.id], 'sandbox')
            }
        },
        async resumeJob (job) {
            if (job.type == 'hls') {
                await useExtension('hlsDownloadPool.resumeJob', [job.id], 'offscreen')
            } else if (job.type == 'dash') {
                await useExtension('dashDownloadPool.resumeJob', [job.id], 'offscreen')
            } else if (job.type == 'chunked') {
                await useExtension('chunkedDownloadPool.resumeJob', [job.id], 'offscreen')
            } else if (job.type == 'native') {
                await useExtension('nativeDownloadPool.resumeJob', [job.id], 'offscreen')
            } else if (job.type == 'download') {
                await useExtension('downloadPool.resumeJob', [job.id], 'sandbox')
            }
        }
    },
    computed: {
        state () {
            return this.job.state
        }
    }
}
</script>